export default {
  zebraPrinter: false,
  checkPrinter: false,
  printerConnected: false,
}